module.exports = __webpack_public_path__ + "static/media/quotes-navy.7b283656.svg";